import Create from "./Create";
import List from "./List";
import Update from "./Update";

export const Address = {
  List: List,
  Update: Update,
  Create: Create,
};
